import script from "./DataProviderEntitySaveActionTabPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataProviderEntitySaveActionTabPane.vue?vue&type=script&lang=ts&setup=true"

import "./DataProviderEntitySaveActionTabPane.vue?vue&type=style&index=0&id=50badd9d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50badd9d"]])

export default __exports__